import { render, staticRenderFns } from "./LuminanceUniformityReportDetail.vue?vue&type=template&id=28e733fa&scoped=true"
import script from "./LuminanceUniformityReportDetail.vue?vue&type=script&lang=js"
export * from "./LuminanceUniformityReportDetail.vue?vue&type=script&lang=js"
import style0 from "./LuminanceUniformityReportDetail.vue?vue&type=style&index=0&id=28e733fa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28e733fa",
  null
  
)

export default component.exports